// extracted by mini-css-extract-plugin
module.exports = {"root":"TableCell_root__2xcK7","wrapper":"TableCell_wrapper__gLU-2","actionsCell":"TableCell_actionsCell__3rXpD"};